import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, from, of } from 'rxjs';
import { MODAL_CONFIG } from '@core-utils';
import { UnsavedChangesModalComponent } from '../modals';
import { UnsavedChangesInterface } from '../types';

export const unsavedChangesGuard: CanDeactivateFn<UnsavedChangesInterface> = (
  component,
) => {
  if (!component.hasUnsavedChanges()) {
    return true;
  }

  const modalRef = inject(NgbModal).open(
    UnsavedChangesModalComponent,
    MODAL_CONFIG,
  );

  return from(modalRef.result as Promise<boolean>).pipe(
    catchError(() => of(false)),
  );
};
